<template>
  <div class="footer">
    <a class="left" :href="'tel:' + customer_phone">
      <img src="../../static/img/phone.png" alt="tel" width="23" />
      <p>咨询</p>
    </a>
    <div class="right">
      <a
        href="https://api.11visa.com/oss/open/channel_stat?channel=6jj6u8io"
        class="btn"
        v-if="!productClosed"
        >开始办理</a
      >
      <span class="product-closed btn" v-if="productClosed">该商品已下架</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Page',
  props: ['productClosed', 'customer_service'],
  data() {
    return {
      customer_phone: '',
    };
  },
  watch: {
    customer_service(newVal) {
      if (newVal) {
        this.customer_phone = newVal.customer_phone;
      }
    },
  },
};
</script>

<style scoped>
.footer {
  height: 65px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: white;
  z-index: 9999;
  display: flex;
  align-items: center;
}
.footer .left {
  flex: 0 1 80px;
  display: block;
  text-align: center;
  text-decoration: none;
}
.footer .left p {
  font-size: 14px;
  color: #666;
}
.footer .right {
  flex: 1;
  padding-right: 15px;
}
.footer .right .btn {
  -webkit-appearance: none;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 42px;
  line-height: 42px;
  border: none;
  border-radius: 4px;
  background-color: #ff5a60;
  color: white;
  width: 100%;
  text-decoration: none;
  font-size: 0.16rem;
}
.product-closed {
  background-color: #cfcfcf !important;
  color: #fff !important;
}
</style>
